import { render, staticRenderFns } from "./textPackUp.vue?vue&type=template&id=e37d36f0&"
import script from "./textPackUp.vue?vue&type=script&lang=ts&"
export * from "./textPackUp.vue?vue&type=script&lang=ts&"
import style0 from "./textPackUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports